/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { PatternSwagger } from 'src/luis/core/services/patterns/patternSwagger';
import { PatternStore } from 'src/luis/core/stores/patternStore';
import { LuisId } from 'src/luis/types/Resource';

/**
 * Converts the pattern swagger type to the store type.
 *
 * @param pattern The swagger object from the api.
 * @returns The store object.
 */
export const patternSwaggerToPatternStore = (pattern: PatternSwagger, labeledIntentId: LuisId) =>
    new PatternStore(pattern.id, { text: pattern.pattern, intentId: <string>labeledIntentId });
